export const lightTheme = [
  // Mui components override
  "--btmNavBg: #F4F4F4",
  "--tlbarGuttersBg: #c2b07e",
  "--appbarBg: #EDEAE0",
  "--tabSltBg: RGB(203,125,64,0.6)",
  "--sliderRailBg: #c2b07e",
  "--dividerBg: #b8b8b8",
  "--dialogBg: linear-gradient(135deg, #fdfcfb 0%, #e2d1c3 100%)",
  "--btmNavActionC: #6f8683",
  "--btmNavActionCSlt: #cb7d40",
  "--appbarC: inherit",
  "--tabSltC: #F4F4F4",
  "--circularC: #cabb8f",
  "--sliderC: #cb7d40",
  "--btnC: #6f8683",
  "--inputBefore: 1px solid rgba(0, 0, 0, 0.42)",
  "--inputAfter: 1px solid #cb7d40",

  // other
  "--background: linear-gradient(90deg, RGB(202, 187, 143, 0.3) 0%, RGB(202, 187, 143, 0.5) 100%)",
  "--aboutSvgF: #6f8683",
  "--textOnPlay: #CC5500"
];

export const darkTheme = [
  // Mui components override
  "--btmNavBg: #1e1e1e",
  "--tlbarGuttersBg: #424242",
  "--appbarBg: #424242",
  "--tabSltBg: #7e7e7e",
  "--sliderRailBg: #c2b07e",
  "--dividerBg: #a8a8a8",
  "--dialogBg: linear-gradient(135deg, #a8a8a8 0%, #7e7e7e 100%)",
  "--btmNavActionC: #bababa",
  "--btmNavActionCSlt: #a88c60",
  "--appbarC: inherit",
  "--tabSltC: #d3d3d3",
  "--circularC: #a8a8a8",
  "--sliderC: #c49102",
  "--btnC: #a88c60",
  "--inputBefore: 1px solid #a8a8a8",
  "--inputAfter: 1px solid #c49102",
  "--typoC: #bababa",

  // other
  "--background: #121212",
  "--aboutSvgF: #a88c60",
  "--textOnPlay: #c49102"
];
